module.exports = {"530827101":"娜允镇","530827102":"勐马镇","530827103":"芒信镇","530827104":"富岩镇","530827201":"景信乡","530827202":"公信乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530827.json
// module id = 2412
// module chunks = 0